"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireDefault(require("styled-components/native"));

var _screenSize = _interopRequireDefault(require("../../screenSize"));

var _ThemeProvider = require("../ThemeProvider");

var _Row = require("./Row");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: ", ";\n  padding: 0 ", "px;\n  margin-left: ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isHidden = function isHidden(_ref) {
  var screenSize = _ref.screenSize,
      smHidden = _ref.smHidden,
      mdHidden = _ref.mdHidden,
      lgHidden = _ref.lgHidden;

  switch (screenSize) {
    case 'sm':
      return smHidden;

    case 'md':
      return mdHidden;

    case 'lg':
      return lgHidden;

    default:
      return false;
  }
};

var toPercent = function toPercent(num, size) {
  return num > size ? '100%' : num / size * 100 + "%";
};

var getColWidth = function getColWidth(_ref2) {
  var sm = _ref2.sm,
      md = _ref2.md,
      lg = _ref2.lg,
      size = _ref2.size,
      rowSize = _ref2.rowSize,
      screenSize = _ref2.screenSize;

  switch (screenSize) {
    case 'sm':
      if (sm >= 0) {
        return toPercent(sm, rowSize);
      }

      break;

    case 'md':
      if (md >= 0) {
        return toPercent(md, rowSize);
      } else if (sm >= 0) {
        return toPercent(sm, rowSize);
      }

      break;

    case 'lg':
      if (lg >= 0) {
        return toPercent(lg, rowSize);
      } else if (md >= 0) {
        return toPercent(md, rowSize);
      } else if (sm >= 0) {
        return toPercent(sm, rowSize);
      }

      break;

    default:
      return toPercent(size, rowSize);
  }

  return toPercent(size, rowSize);
};

var getColOffset = function getColOffset(_ref3) {
  var smOffset = _ref3.smOffset,
      mdOffset = _ref3.mdOffset,
      lgOffset = _ref3.lgOffset,
      offset = _ref3.offset,
      rowSize = _ref3.rowSize,
      screenSize = _ref3.screenSize;
  return getColWidth({
    sm: smOffset,
    md: mdOffset,
    lg: lgOffset,
    size: offset,
    rowSize: rowSize,
    screenSize: screenSize
  });
};

var ColumnView = _native.default.View(_templateObject(), function (props) {
  return getColWidth(props);
}, function (props) {
  return props.muiTheme.spacing / 2;
}, function (props) {
  return getColOffset(props);
}, function (props) {
  return isHidden(props) ? 'display: none' : '';
}, function (props) {
  return props.styles;
});

var Column =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Column, _Component);

  function Column() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Column.prototype;

  _proto.render = function render() {
    var theme = (0, _ThemeProvider.getTheme)('Grid', this.props, this.context.theme);
    return _react.default.createElement(ColumnView, (0, _extends2.default)({}, this.props, {
      rowSize: this.context.rowSize,
      muiTheme: theme
    }), this.props.children);
  };

  return Column;
}(_react.Component);

(0, _defineProperty2.default)(Column, "contextType", _Row.RowContext);
(0, _defineProperty2.default)(Column, "defaultProps", {
  size: 1,
  offset: 0,
  nowrap: false,
  alignItems: 'center',
  justifyContent: 'center'
});

var _default = (0, _screenSize.default)(Column);

exports.default = _default;